export const facultySourceRoleRoutes = {
    path: ':uniuuid/position/:uuid',
    name: 'position-detail',
    meta: {
        label: 'Position Details'
    },
    component: () => import("@/pages/position/PositionDetail.vue")
}